import request from '../../utils/request'
import requestBase,{ headers as ReqHeaders } from '../requesBase';
const dhImage = 'pc_web/dh-image';
const dhCanvasBackground = 'dh-canvas-background';
const dhBackground = 'dh-background';
const dhEnterprise = 'dh-logo';
const dhMaterial = 'dh-material';
const dhTpl = 'pc_web/dh-template'
const dhVideo = 'pc_web/dh-video'
const dhSound = 'dh-sound'
const dhText = 'dh-text'
const dhDraft = 'dh-draft'


const mainModule = {
    /**用户信息*/
    getUserInfo(headers){
        return request({
            url: 'pc_web/site/user-info',
            method: 'post',
            headers
        })
    },

    /** 模板模块 */

    // 获取模板列表
    getTemplateList(data, headers) {
        return request({
            url: dhTpl + '/list',
            method: 'post',
            data,
            headers
        })
    },
    //获取模板分组列表
    getTemplateGroupList(data, headers) {
        return request({
            url: dhTpl + '/group-list',
            method: 'post',
            data,
            headers
        })
    },

    // 获取模板详情
    getTemplateDetail(data, headers) {
        return request({
            url: dhTpl + '/detail',
            method: 'post',
            data,
            headers
        })
    },

    /** 数字人形象模块 */

    // 获取官方数字人形象列表
    getOfficialImageList(data, headers) {
        return request({
            url: dhImage + '/official-list',
            method: 'post',
            data,
            headers
        })
    },

    // 获取我的数字人形象列表(已合成)
    getMyImageList(data, headers) {
        return request({
            url: dhImage + '/property-list',
            method: 'post',
            data,
            headers
        })
    },

    // 获取我的数字人形象列表(所有状态)
    getMyImageListAll(data, headers) {
        return request({
            url: dhImage + '/custom-record-list',
            method: 'post',
            data,
            headers
        })
    },

    // 编辑我的数字人形象名字
    editMyImageTitle(data, headers) {
        return request({
            url: dhImage + '/edit',
            method: 'post',
            data,
            headers
        })
    },

    // 删除我的数字人形象
    deleteMyImage(data, headers) {
        return request({
            url: dhImage + '/delete',
            method: 'post',
            data,
            headers
        })
    },

    /** 创作模块 */

    // 获取初始数据
    getInitTplData(headers) {
        return request({
            url: dhVideo + '/init-data ',
            method: 'post',
            headers
        })
    },

    //获取我的创作作品列表
    getMyCreationList(data, headers) {
        return request({
            url: dhVideo + '/make-list',
            method: 'post',
            data,
            headers
        })
    },

    //获取我的创作作品详情
    getMyCreationDetail(data, callback) {
      requestBase.post('/dh-video/make-result', data).then(res => {
        callback(res)
      })
    },

    // 编辑我的创作作品名字
    editMyCreationTitle(data, headers) {
        return request({
            url: dhVideo + '/edit-name',
            method: 'post',
            data,
            headers
        })
    },

    // 删除我的创作作品
    deleteMyCreation(data, headers) {
        return request({
            url: dhVideo + '/delete-record',
            method: 'post',
            data,
            headers
        })
    },

    // 获取文字脚本预计时长
    getTextDuration(data, callback) {
      requestBase.post('/dh-video/get-duration', data).then(res => {
          callback(res)
      })
    },

    //删除未使用的音频文件
    deleteUnusedAudio(data, callback) {
        requestBase.post('/dh-video/delete-audio', data).then(res => {
            callback(res)
        })
    },

    //开始试听
    beginAudition(data, callback) {
        requestBase.post('/dh-video/audition', data).then(res => {
            callback(res)
        })
    },

    //获取试听结果
    getAuditionResult(data, callback) {
        requestBase.post('/dh-video/audition-result', data).then(res => {
            callback(res)
        })
    },

    //开始制作视频
    beginMakeVideo(data, callback) {
        requestBase.post('/dh-video/start-make', data).then(res => {
            callback(res)
        })
    },

    //重新制作视频
    retryMakeVideo(data, callback) {
      requestBase.post('/dh-video/retry-make', data).then(res => {
        callback(res)
      })
    },

    /** 声音模块 */

    // 获取我的创作声音列表(已合成)
    getMySoundList(data, callback) {
        requestBase.post(dhSound + '/property-list', data).then(res => {
            callback(res)
        })
    },

    // 获取我的创作声音列表(所有状态)
    getMySoundListAll(data, callback) {
        requestBase.post(dhSound + '/clone-record-list', data).then(res => {
            callback(res)
        })
    },

    // 编辑我的创作声音名字
    editMySoundTitle(data, callback, callbackErr) {
        requestBase.post(dhSound + '/edit', data).then(res => {
            callback(res)
        }).catch(err => {
            callbackErr(err)
        })
    },

    // 删除我的创作声音名字
    deleteMySound(data, callback, callbackErr) {
        requestBase.post(dhSound + '/delete', data).then(res => {
            callback(res)
        }).catch(err => {
            callbackErr(err)
        })
    },

    //获取声音分组列表
    getSoundGroupList(data, callback) {
        requestBase.post(dhSound + '/group-list', data).then(res => {
            callback(res)
        })
    },

    //获取官方声音列表
    getOfficialSoundList(data, callback) {
        requestBase.post(dhSound + '/list', data).then(res => {
            callback(res)
        })
    },

    /** 素材模块begin */

    // 获取素材分组列表
    getMaterialGroupList(data, callback) {
        requestBase.post(dhMaterial + '/group-list', data).then(res => {
            callback(res);
        })
    },

    // 获取素材列表
    getMaterialList(data, callback) {
        requestBase.post(dhMaterial + '/list', data).then(res => {
            callback(res);
        })
    },

    // 获取我的素材列表
    getMineMaterialList(data, callback) {
        requestBase.post(dhMaterial + '/my-list', data).then(res => {
            callback(res);
        })
    },

    // 添加我的素材
    addMineMaterial(data, callback) {
        requestBase.post(dhMaterial + '/add', data).then(res => {
            callback(res);
        })
    },
    // 修改我的素材
    editMineMaterial(data, callback) {
        requestBase.post(dhMaterial + '/edit', data).then(res => {
            callback(res);
        })
    },
    // 删除我的素材
    deleteMineMaterial(data, callback) {
        requestBase.post(dhMaterial + '/delete', data).then(res => {
            callback(res);
        })
    },

    // 预设颜色值
    getPresetsColorList(data,callback) {
        requestBase.post(dhMaterial + '/color-list', data).then(res => {
            callback(res);
        })
    },

    /** -----end------- */

    /** 背景模块begin */

    // 获取背景分组列表
    getBgGroupList(data, callback) {
        requestBase.post(dhCanvasBackground + '/group-list', data).then(res => {
            callback(res);
        })
    },

    // 获取纹理背景列表
    getTextureBgList(data, callback) {
        requestBase.post(dhCanvasBackground + '/img-list', data).then(res => {
            callback(res);
        })
    },

    // 获取颜色背景列表
    getColorBgList(data, callback) {
        requestBase.post(dhCanvasBackground + '/color-list', data).then(res => {
            callback(res);
        })
    },
    // 获取我的背景列表
    getMineBgList(data, callback) {
        requestBase.post(dhCanvasBackground + '/my-list', data).then(res => {
            callback(res);
        })
    },
    // 添加我的背景
    addMineBg(data, callback) {
        requestBase.post(dhCanvasBackground + '/add', data).then(res => {
            callback(res);
        })
    },
    // 修改我的背景
    editMineBg(data, callback) {
        requestBase.post(dhCanvasBackground + '/edit', data).then(res => {
            callback(res);
        })
    },
    // 删除我的背景
    deleteMineBg(data, callback) {
        requestBase.post(dhCanvasBackground + '/delete', data).then(res => {
            callback(res);
        })
    },

    /** -----end------- */

    /** 形象底纹模块begin */

    // 获取纹理底纹分组列表
    getImageShapeGroupList(data, callback) {
        requestBase.post(dhBackground + '/group-list', data).then(res => {
            callback(res);
        })
    },

    // 获取纹理底纹列表
    getTextureImageShapeList(data, callback) {
        requestBase.post(dhBackground + '/img-list', data).then(res => {
            callback(res);
        })
    },

    // 获取颜色底纹列表
    getColorImageShapeList(data, callback) {
        requestBase.post(dhBackground + '/color-list', data).then(res => {
            callback(res);
        })
    },
    // 获取我的形象底纹列表
    getMineImageShapeList(data, callback) {
        requestBase.post(dhBackground + '/my-list', data).then(res => {
            callback(res);
        })
    },
    // 添加我的形象底纹
    addMineImageShape(data, callback) {
        requestBase.post(dhBackground + '/add', data).then(res => {
            callback(res);
        })
    },
    // 修改我的形象底纹
    editMineImageShape(data, callback) {
        requestBase.post(dhBackground + '/edit', data).then(res => {
            callback(res);
        })
    },
    // 删除我的形象底纹
    deleteMineImageShape(data, callback) {
        requestBase.post(dhBackground + '/delete', data).then(res => {
            callback(res);
        })
    },

    /** -----end------- */


    /** 企业标识模块begin */

    // 获取我的logo列表
    getMineLogoList(data, callback) {
        requestBase.post(dhEnterprise + '/list', data).then(res => {
            callback(res);
        })
    },

    // 添加我的logo
    addMineLogo(data, callback) {
        requestBase.post(dhEnterprise + '/add', data).then(res => {
            callback(res);
        })
    },
    // 修改我的logo
    editMineLogo(data, callback) {
        requestBase.post(dhEnterprise + '/edit', data).then(res => {
            callback(res);
        })
    },
    // 删除我的logo
    deleteMineLogo(data, callback) {
        requestBase.post(dhEnterprise + '/delete', data).then(res => {
            callback(res);
        })
    },

    /** -----end------- */

    /** 文本相关begin */

    // 获取字体列表
    getFontList(data, callback) {
        requestBase.post(dhText + '/font-list', data).then(res => {
            callback(res);
        })
    },
    // 获取百度翻译支持语种列表
    getTranslationLanguageList(data, callback) {
        requestBase.post(dhText + '/translation-language', data).then(res => {
            callback(res);
        })
    },

    // 百度单文本翻译
    baiduSingleTranslation(data, callback) {
        requestBase.post(dhText + '/single-translation', data).then(res => {
            callback(res);
        })
    },
    // 百度多文本翻译
    baiduMultiTranslation(data, callback) {
        requestBase.post(dhText + '/multi-translation', data).then(res => {
            callback(res);
        })
    },

    /** -----end------ */

    /** 草稿相关begin */

    // 获取草稿列表
    getDraftList(data, callback) {
        requestBase.post(dhDraft + '/list', data).then(res => {
            callback(res);
        })
    },
    // 获取数字人草稿详情
    getDraftDetail(data, callback) {
        requestBase.post(dhDraft + '/detail', data).then(res => {
            callback(res)
        })
    },
    // 添加数字人草稿
    addDraft(data, callback) {
        data.subtitle_data =  data.subtitle_data?JSON.stringify(data.subtitle_data):null;
        requestBase.post(dhDraft + '/add', data).then(res => {
            callback(res)
        })
    },
    // 修改数字人草稿
    editDraft(data, callback) {
        data.subtitle_data =  data.subtitle_data?JSON.stringify(data.subtitle_data):null;
        requestBase.post(dhDraft + '/edit',data).then(res => {
            callback(res)
        })
    },
    // 修改数字人草稿名称
    editDraftName(data, callback) {
        requestBase.post(dhDraft + '/edit-name',data).then(res => {
            callback(res)
        })
    },
    // 复制数字人草稿
    copyDraft(data, callback) {
        requestBase.post(dhDraft + '/copy', data).then(res => {
            callback(res)
        })
    },
    // 删除数字人草稿
    deleteDraft(data, callback) {
        requestBase.post(dhDraft + '/delete', data).then(res => {
            callback(res)
        })
    },
    /** -----end------ */
    // 获取企业标识列表
    getLogoList(data, headers) {
        return request({
            url: dhTpl + '/logo-list',
            method: 'post',
            data,
            headers
        })
    },

    // 上传背景/logo
    uploadImg(data, headers) {
        return request({
            url: 'site/upload-img',
            method: 'post',
            data,
            headers
        })
    },

    // 删除oss的文件
    deleteOssFile(data, headers) {
        return request({
            url: 'site/del-file',
            method: 'post',
            data,
            headers
        })
    },

    /** 字幕模块begin */

    // 开始生成字幕
    generateSubtitle(data, controller) {
        return request({
            url: dhVideo + '/generate-subtitle',
            method: 'post',
            data,
            signal: controller.signal,
            headers : ReqHeaders,
        })
    },

    // 获取字幕生成结果
    getSubtitleResult(data, controller) {
        return request({
            url: dhVideo + '/generate-result',
            method: 'post',
            data,
            signal: controller.signal,
            headers : ReqHeaders,
        })
    },

    /** -----end------- */
}

export default mainModule